interface ApiConfigSchema {
    url: {
        portal: string;
        authorisation: string;
        medicationsManagement: string;
        healthIdentifier: string;
    };
    featureFlags?: { qrcode: boolean };
    topbarFlags?: { showPrescriptionPolicyBanner: boolean };
}
let ApiConfig: ApiConfigSchema;

export function configureApi(settings: any) {
    ApiConfig = {
        url: {
            portal: settings.apiEndpoints.portal,
            authorisation: settings.apiEndpoints.authorisation,
            medicationsManagement: settings.apiEndpoints.medicationsManagement,
            healthIdentifier: settings.apiEndpoints.healthIdentifier
        },
        featureFlags: { qrcode: settings.featureFlags?.qrcode },
        topbarFlags: { showPrescriptionPolicyBanner: settings.topbarFlags.showPrescriptionPolicyBanner }
    };
}

export function getApiConfig() {
    return ApiConfig;
}
